import React, { useState, useEffect } from 'react'
import { cn } from '../utils/cn'
import Container from './container'

export default function MarcaVertical({
  logoSrc,
  backgroundImage,
  buttonBgGradient,
  infoText,
}) {
  const [showInfo, setShowInfo] = useState(false)
  const [animateInfo, setAnimateInfo] = useState(false)

  useEffect(() => {
    if (showInfo) {
      setTimeout(() => setAnimateInfo(true), 50)
    } else {
      setAnimateInfo(false)
    }
  }, [showInfo])

  return (
    <div
      className={`relative w-full h-[calc(100vw+6.12rem)] lg:h-[380px] bg-cover bg-center flex items-center overflow-hidden bg-[url('${backgroundImage}')]`}
    >
      <Container className={cn('mt-10', showInfo && 'mb-auto lg:mb-0')}>
        <div
          className={`transition-all duration-500 w-full ${
            showInfo
              ? 'flex flex-col justify-between items-center md:flex-row'
              : 'flex flex-col items-center justify-center'
          }`}
        >
          <div
            className={`transition-all duration-500 ${
              showInfo ? '' : 'text-center mb-8'
            }`}
          >
            <img
              src={logoSrc}
              alt="Logo"
              className="transition-all duration-500 w-[600px] lg:w-[430px] mx-auto"
            />
          </div>
          {showInfo ? (
            <div
              className="absolute px-8 bottom-0 lg:w-[430px] lg:h-[150px] transition-all duration-700 lg:pr-0 lg:static lg:pl-24 lg:max-w-[calc(100%-430px)]"
              style={{
                opacity: animateInfo ? 1 : 0,
                transform: animateInfo ? 'translateX(0)' : 'translateX(50px)',
              }}
            >
              <div
                className="bg-[#FFFFFF17] shadow-2xl shadow-black text-white backdrop-blur-sm p-8 pb-10 whitespace-break-spaces lg:p-6 rounded-t-md border border-b-0 border-white/80 transition-all duration-700 flex flex-row lg:border-b-1 lg:rounded-md"
                style={{
                  opacity: animateInfo ? 1 : 0,
                  transform: animateInfo ? 'scale(1)' : 'scale(0.95)',
                }}
              >
                <p className="text-4xl font-inter-regular">* </p>
                <p className="ml-2 font-inter-light text-lg leading-relaxed tracking-wide">
                  {infoText}
                </p>
              </div>
            </div>
          ) : (
            <button
              type="button"
              onClick={() => setShowInfo(true)}
              className="text-2xl px-8 py-2 bg-white rounded-full hover:scale-105 transition-all duration-300 hover:cursor-pointer"
            >
              <span
                className={`bg-gradient-to-r ${buttonBgGradient} bg-clip-text text-transparent font-medium transition-transform duration-200`}
              >
                Saiba mais
              </span>
            </button>
          )}
        </div>
      </Container>
    </div>
  )
}
